import { FETCH_SESSION, FETCH_SESSION_BY_DATE, FETCH_SESSION_BY_PROPOSAL } from '../constants/ActionTypes'
import { getSessions, getSessionsByDate, getSessionsByProposal } from '../api/ispyb.js'

import { axios } from 'config/axios'

export function fetchSessions(user) {
  return {
    type: FETCH_SESSION,
    payload: axios.get(getSessions(user)),
  }
}

export function fetchSessionsByDate(user, startDate, endDate) {
  return {
    type: FETCH_SESSION_BY_DATE,
    payload: axios.get(getSessionsByDate(user, startDate, endDate)),
  }
}

export function fetchSessionsByProposal(user, proposal) {
  return {
    type: FETCH_SESSION_BY_PROPOSAL,
    payload: axios.get(getSessionsByProposal(user, proposal)),
  }
}
